import * as React from 'react'
import './style/user-activity-log-well.scss'
import * as CopyToClipboard from 'react-copy-to-clipboard'
import { AppService } from '@halo/services/app.service'
import { Container } from 'typescript-ioc/es5'
import { classnames } from '@halo/_utils/classnames'
import { Drawer, Well } from '@pushly/aqe/lib/components'
import * as moment from 'moment-timezone'
import { CompoundTable } from '@halo/components/compound-table/compound-table'
import { Loading3QuartersOutlined, LinkOutlined, DeploymentUnitOutlined } from '@ant-design/icons'
import { Table, Tag } from 'antd'
import { simpleNotification } from '@pushly/aqe/lib/utils'
import { AntdTableEmptyPlaceholder } from '@halo/components/antd-table-empty-placeholder/antd-table-empty-placeholder'
import { UserDto } from '@halo/dtos/user.dto'
import { UserService } from '@halo/services/user.service'
import { AccountService } from '@halo/services/account.service'
import * as randomstring from 'randomstring'
import * as Bowser from 'bowser'
import JSONPretty from 'react-json-pretty'
import cloneDeep from 'clone-deep'
import queryString from 'query-string'
import SwSimpleLinkPagination from '@halo/components/sw-simple-link-pagination/sw-simple-link-pagination'
import { IApiResponsePaginationLinks } from '@halo/interfaces/api-response-pagination-links'

interface IActivityLogDetails {
    record: any
    visible: boolean
    onClose: (e: any) => void
}

class ActivityLogDetails extends React.Component<IActivityLogDetails, any> {
    protected appService: AppService
    protected accountService: AccountService

    public constructor(props: IActivityLogDetails) {
        super(props)

        this.appService = Container.get(AppService)
        this.accountService = Container.get(AccountService)
    }

    public render() {
        const browserData = this.getBrowserData()
        const hasBrowserData = Object.keys(browserData).length > 0 && !!browserData.browser?.name

        return (
            <Drawer
                className={classnames('ald')}
                title={!this.record ? 'Loading...' : this.getHeading()}
                placement="right"
                closable={true}
                hideFooter={true}
                onClose={this.handleClose}
                open={this.props.visible}
            >
                {this.props.visible && (
                    <>
                        <Well title="Summary" hideFooter={true}>
                            <div className={classnames('form-layout-row')}>
                                <div className={classnames('form-layout-row-label')}>ID</div>
                                <div className={classnames('form-layout-row-value')}>
                                    {this.record.id}

                                    <span className="log-id-link">
                                        <CopyToClipboard
                                            text={this.getLogIdLink()}
                                            onCopy={() => {
                                                simpleNotification('success', 'Copied', undefined, undefined, true)
                                            }}
                                        >
                                            <LinkOutlined />
                                        </CopyToClipboard>
                                    </span>
                                </div>
                            </div>
                            <div className={classnames('form-layout-row')}>
                                <div className={classnames('form-layout-row-label')}>Event Time</div>
                                <div className={classnames('form-layout-row-value')}>{this.getLogTime()}</div>
                            </div>
                            <div className={classnames('form-layout-row')}>
                                <div className={classnames('form-layout-row-label')}>Method</div>
                                <div className={classnames('form-layout-row-value')}>{this.getEventMethod()}</div>
                            </div>
                            <div className={classnames('form-layout-row')}>
                                <div className={classnames('form-layout-row-label')}>URL</div>
                                <div className={classnames('form-layout-row-value')}>{this.getEventPath()}</div>
                            </div>
                            <div className={classnames('form-layout-row')}>
                                <div className={classnames('form-layout-row-label')}>Status</div>
                                <div className={classnames('form-layout-row-value')}>{this.getEventStatus()}</div>
                            </div>
                            <div className={classnames('form-layout-row')}>
                                <div className={classnames('form-layout-row-label')}>Referrer</div>
                                <div className={classnames('form-layout-row-value')}>{this.getEventReferer()}</div>
                            </div>
                            <div className={classnames('form-layout-row')}>
                                <div className={classnames('form-layout-row-label')}>Platform Version</div>
                                <div className={classnames('form-layout-row-value')}>
                                    {this.getEventXApplicationVersion()}
                                </div>
                            </div>
                            <div className={classnames('form-layout-row')}>
                                <div className={classnames('form-layout-row-label')}>API Source</div>
                                <div className={classnames('form-layout-row-value')}>{this.getEventApi()}</div>
                            </div>
                            <div className={classnames('form-layout-row')}>
                                <div className={classnames('form-layout-row-label')}>IP Address</div>
                                <div className={classnames('form-layout-row-value')}>{this.getEventIP()}</div>
                            </div>
                        </Well>

                        <Well title="UserAgent Details" hideFooter={true}>
                            {hasBrowserData && (
                                <>
                                    <div className={classnames('form-layout-row')}>
                                        <div className={classnames('form-layout-row-label')}>Platform</div>
                                        <div className={classnames('form-layout-row-value')}>
                                            {browserData.platform?.vendor}
                                        </div>
                                    </div>
                                    <div className={classnames('form-layout-row')}>
                                        <div className={classnames('form-layout-row-label')}>Operating System</div>
                                        <div className={classnames('form-layout-row-value')}>
                                            {browserData.os?.name} ({browserData.os?.version})
                                        </div>
                                    </div>
                                    <div className={classnames('form-layout-row')}>
                                        <div className={classnames('form-layout-row-label')}>Browser</div>
                                        <div className={classnames('form-layout-row-value')}>
                                            {browserData.browser?.name} ({browserData.browser?.version})
                                        </div>
                                    </div>
                                </>
                            )}

                            <div className={classnames('form-layout-row')}>
                                <div className={classnames('form-layout-row-label')}>RAW UserAgent</div>
                                <div className={classnames('form-layout-row-value')}>{this.getEventUA()}</div>
                            </div>
                        </Well>

                        <Well title="Request Path Parameters" hideFooter={true}>
                            {!this.record.request?.params ? (
                                <span className="placeholder-no-data">No path parameters</span>
                            ) : (
                                this.renderRequestPathParams()
                            )}
                        </Well>

                        <Well title="Request Query Parameters" hideFooter={true}>
                            {!this.getEventRequestQueryParams() ? (
                                <span className="placeholder-no-data">No query parameters</span>
                            ) : (
                                this.renderRequestQueryParams()
                            )}
                        </Well>

                        {this.getEventMethod() !== 'GET' && (
                            <Well title={`Request ${this.getEventMethod()} Body`} hideFooter={true}>
                                {!this.getEventRequestBody() ? (
                                    <span className="placeholder-no-data">No {this.getEventMethod()} body</span>
                                ) : (
                                    <div className="code-snippet-wrapper request-body">
                                        <pre className="code-snippet">
                                            <JSONPretty json={this.getEventRequestBody()} />
                                        </pre>
                                    </div>
                                )}
                            </Well>
                        )}

                        <Well title="Response Body" hideFooter={true}>
                            {!this.record.response?.body ? (
                                <span className="placeholder-no-data">No response body</span>
                            ) : (
                                <div className="code-snippet-wrapper request-body">
                                    <pre className="code-snippet">
                                        <JSONPretty json={this.record.response.body || {}} />
                                    </pre>
                                </div>
                            )}
                        </Well>
                    </>
                )}
            </Drawer>
        )
    }

    protected renderRequestPathParams() {
        const paramKeys = Object.keys(this.record.request.params)

        return paramKeys.map((param) => (
            <div key={param} className={classnames('form-layout-row')}>
                <div className={classnames('form-layout-row-label')}>{param}</div>
                <div className={classnames('form-layout-row-value')}>{this.record.request.params[param]}</div>
            </div>
        ))
    }

    protected renderRequestQueryParams() {
        const query = this.getEventRequestQueryParams()
        const paramKeys = Object.keys(query)

        return paramKeys.map((param) => (
            <div key={param} className={classnames('form-layout-row')}>
                <div className={classnames('form-layout-row-label')}>{param}</div>
                <div className={classnames('form-layout-row-value')}>{query[param]}</div>
            </div>
        ))
    }

    protected get record(): any {
        return this.props.record
    }

    protected getHeading(): React.ReactNode {
        if (!this.record) {
            return ''
        }

        return (
            <span>
                {this.getEventMethod()} {this.getEventPath()}
            </span>
        )
    }

    protected getLogIdLink(): string {
        const qs = queryString.parse(location.search)
        qs.log_id = this.record.id

        const newQs = queryString.stringify(qs)
        let newLoc = location.href.replace(/\?.+$/, '')
        newLoc += `?${newQs}`

        return newLoc
    }

    protected getLogTime(): string {
        if (!this.record) {
            return ''
        }

        return moment.tz(this.record.event_time_utc, 'America/Chicago').format('LLLL')
    }

    protected getEventMethod(): string {
        if (!this.record) {
            return ''
        }

        return this.record.request?.method ?? this.record.request_type
    }

    protected getEventPath(): string {
        if (!this.record) {
            return ''
        }

        return this.record.request?.path || (this.record.request_body?._req_?.url ?? '--')
    }

    protected getEventStatus(): string {
        if (!this.record) {
            return ''
        }

        return this.record.response?.status_code ?? 'UNK'
    }

    protected getEventReferer(): string {
        if (!this.record) {
            return ''
        }

        let ref = this.record.request?.headers?.['referer'] ?? '--'
        if (ref === '--') {
            ref = this.record.request_body?._req_?.headers?.['referer'] ?? '--'
        }

        return ref
    }

    protected getEventIP(): string {
        if (!this.record) {
            return ''
        }

        return this.record.request?.ip_address ?? this.record.ip_address ?? '--'
    }

    protected getEventUA(): string {
        if (!this.record) {
            return ''
        }

        return this.record.request?.user_agent ?? this.record.user_agent ?? '--'
    }

    protected getEventApi(): string {
        if (!this.record) {
            return ''
        }

        return this.record.event_meta?.api_name ?? '--'
    }

    protected getEventXApplicationVersion(): string {
        if (!this.record) {
            return ''
        }

        let ver = this.record.request?.headers?.['x-application-version'] ?? '--'
        if (ver === '--') {
            ver = this.record.request_body?._req_?.headers?.['x-application-version'] ?? '--'
        }

        return ver
    }

    protected getEventRequestQueryParams(): any | undefined {
        let params: any

        if (!!this.record) {
            params = this.record.request?.query

            if (!params) {
                params = this.record.request_body?._req_?.query
            }

            if (!params || Object.keys(params).length === 0) {
                params = undefined
            }
        }

        return params
    }

    protected getEventRequestBody(): any | undefined {
        let body: any

        if (!!this.record) {
            body = this.record.request?.body

            if (!body) {
                body = cloneDeep(this.record.request_body)

                if (!!body) {
                    delete body._req_
                }
            }

            if (!body || Object.keys(body).length === 0) {
                body = undefined
            }
        }

        return body
    }

    protected getBrowserData(): any {
        let data = {}

        try {
            data = Bowser.parse(this.getEventUA())
        } catch (_err) {}

        return data
    }

    protected handleClose = async () => {
        this.props.onClose(null)
    }
}

interface IUserDetails {
    loading: boolean
    user: UserDto & any
    accountId: number
}

interface IACDState {
    loadingLogs: boolean
    activeRecord?: boolean
    drawerKey?: string
    page: number
    paginationLinks?: IApiResponsePaginationLinks
}

const ogPopState: any = window.onpopstate

export class UserActivityLogWell extends React.Component<IUserDetails, IACDState> {
    public state: IACDState = {
        loadingLogs: true,
        page: 1,
    }

    protected appService: AppService
    protected userService: UserService

    public constructor(props: IUserDetails) {
        super(props)

        this.appService = Container.get(AppService)
        this.userService = Container.get(UserService)
    }

    public componentDidMount(): void {
        this.fetchRecordLogs(this.checkForPathLogRequest)

        window.addEventListener('popstate', this.handleHistoryChange)
    }

    public componentWillUnmount(): void {
        window.removeEventListener('popstate', this.handleHistoryChange)
    }

    public render() {
        return (
            <Well className={classnames('user-alw', 'type-2')} title="Activity Logs" hideFooter={true}>
                <CompoundTable>
                    <Table
                        size="small"
                        rowKey={(event: any) => event.id.toString()}
                        className={classnames('user-activity-logs')}
                        dataSource={(this.props.user || {}).logs || []}
                        loading={
                            (this.props.loading || this.state.loadingLogs) && {
                                indicator: <Loading3QuartersOutlined spin={true} />,
                            }
                        }
                        locale={{
                            emptyText: <AntdTableEmptyPlaceholder text="Events" icon={<DeploymentUnitOutlined />} />,
                        }}
                        pagination={false}
                        footer={(currentTableData) => (
                            <SwSimpleLinkPagination
                                currentTableData={currentTableData}
                                links={this.state.paginationLinks}
                                onPrev={(_ev, _link, config) => {
                                    this.setState({ page: config.current! }, () => this.fetchRecordLogs())
                                }}
                                onNext={(_ev, _link, config) => {
                                    this.setState({ page: config.current! }, () => this.fetchRecordLogs())
                                }}
                            />
                        )}
                        onRow={(record) => ({
                            onClick: (_ev) => this.handleLogClick(record),
                        })}
                    >
                        <Table.Column
                            className="status"
                            title="Status"
                            key="response.body.status_code"
                            dataIndex={['response', 'body', 'status_code']}
                            render={this.renderStatusColumn}
                        />
                        <Table.Column
                            className="description"
                            title="Description"
                            key="request.path"
                            dataIndex={['request', 'path']}
                            render={this.renderDescriptionColumn}
                        />
                        <Table.Column
                            className="log-time"
                            title="Event Time"
                            key="event_time_utc"
                            dataIndex="event_time_utc"
                            render={(value, _log) => {
                                return moment.tz(value, 'America/Chicago').format('LLLL')
                            }}
                        />
                    </Table>
                </CompoundTable>

                <ActivityLogDetails
                    key={this.state.drawerKey}
                    visible={!!this.state.activeRecord}
                    record={this.state.activeRecord}
                    onClose={this.handleDrawerClose}
                />
            </Well>
        )
    }

    protected renderStatusColumn = (value: any, log: any) => {
        const code = value || log.response.status_code || 'UNK'
        let msg = 'OK'

        if (code !== 'UNK' && code >= 300) {
            msg = 'ERR'
        }

        const TAG_TEXT_COLOR = '#464D53'
        const GRAY_TAG_COLOR = '#EBEBEB'
        const WARNING_TAG_COLOR = '#F8D990'

        return (
            <Tag
                color={msg === 'OK' ? GRAY_TAG_COLOR : WARNING_TAG_COLOR}
                style={{
                    color: TAG_TEXT_COLOR,
                }}
            >
                {`${code} ${msg}`}
            </Tag>
        )
    }

    protected renderDescriptionColumn = (value: any, _log: any) => {
        const path = value || (_log?.request_body?._req_?.url ?? '/unknown_path')
        const method = _log.request?.method ?? _log.request_type

        return (
            <>
                <span className={`method-${method.toLowerCase()}`}>{method}</span> {path}
            </>
        )
    }

    protected handleLogClick = (record: any): void => {
        this.setState({ activeRecord: record, drawerKey: randomstring.generate() })
        this.updateQueryStringLogId(record.id)
    }

    protected handleDrawerClose = async () => {
        this.setState({ activeRecord: false, drawerKey: undefined })
    }

    /**
     * each history change on current view should
     * check to see if navigating to another log id
     */
    protected handleHistoryChange = () => {
        this.checkForPathLogRequest()
    }

    /**
     * checks for log_id in query string
     * if exists: open drawer to requested log
     * if not exists and drawer is open: close drawer
     */
    protected checkForPathLogRequest = () => {
        const qs = queryString.parse(location.search)
        if (qs.log_id) {
            const logs = this.props.user?.logs ?? []
            const initialLog = logs.find((log: any) => log.id?.toString() === qs.log_id.toString())
            if (initialLog) {
                this.handleLogClick(initialLog)
            }
        } else if (this.state.activeRecord) {
            // close drawer
            this.setState({
                activeRecord: undefined,
                drawerKey: undefined,
            })
        }
    }

    /**
     * appends or replaces log_id param in the current
     * path and silently updates history state when
     * the log_id has changed (sans removed)
     *
     * removing the log_id should not update history state
     * to avoid unnecessary browser navigation
     */
    protected updateQueryStringLogId(logId: string | number) {
        const qs = queryString.parse(location.search)
        let shouldUpdateHistory = false

        if (qs.log_id?.toString() !== logId.toString()) {
            qs.log_id = logId.toString()
            shouldUpdateHistory = true
        }

        // only replace param if log id passed
        // removing log id should not create new history state
        if (shouldUpdateHistory && history.pushState) {
            const newQs = queryString.stringify(qs)

            let newLoc = location.href.replace(/\?.+$/, '')
            newLoc += `?${newQs}`

            history.pushState({ search: queryString.stringify(qs) }, document.title, newLoc)
        }
    }

    protected async fetchRecordLogs(cb?: () => any): Promise<void> {
        if (this.props.loading) {
            setTimeout(() => this.fetchRecordLogs(cb), 50)
            return
        }

        const state: any = { loadingLogs: true }
        await this.setState(state)

        const { user, accountId } = this.props
        const {
            ok,
            data: logs,
            meta,
        } = await this.userService.fetchEventLogs(user.id, accountId, {
            showLoadingScreen: false,
            query: {
                page: this.state.page,
            },
        })

        state.loadingLogs = false
        if (ok) {
            const rootLogs = (logs || []).filter((log: any) => !log.source_event_id)

            user.logs = rootLogs
            state.paginationLinks = meta.links ?? state.paginationLinks
        }

        this.setState(state)
        cb?.()
    }
}
